import PRODUCT_TYPE from "../const/productType";
export var AccountType;
(function (AccountType) {
    AccountType["LOAN"] = "loan";
    AccountType["LOAN_LEGACY"] = "loanLegacy";
    AccountType["CARD"] = "card";
    AccountType["PAY_IN_4"] = "payIn4";
    AccountType["SECURED_INSTALLMENT_LOAN"] = "securedInstallmentLoan";
})(AccountType || (AccountType = {}));
/**
 * Based on the API product type, return the broader account-details type
 */
var getAccountType = function (type) {
    switch (type) {
        case PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR:
            return AccountType.PAY_IN_4;
        case PRODUCT_TYPE.INSTALLMENT_LOAN:
            return AccountType.LOAN_LEGACY;
        case PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY:
            return AccountType.LOAN;
        case PRODUCT_TYPE.DUAL_CARD:
        case PRODUCT_TYPE.LIMITED_USE_DUAL_CARD:
        case PRODUCT_TYPE.BUSINESS_RETAIL_CARD:
        case PRODUCT_TYPE.PRIVATE_LABEL:
            return AccountType.CARD;
        case PRODUCT_TYPE.INSTALLMENT_LOAN_SECURED:
            return AccountType.SECURED_INSTALLMENT_LOAN;
        /* istanbul ignore next */
        default:
            throw new Error("Unknown product type");
    }
};
export default getAccountType;
//# sourceMappingURL=getAccountType.js.map